// js
import React from 'react';
import PropTypes from 'prop-types';
import SecurityDetail from '../../containers/analytics/SecurityDetail';


const SecurityCriticalInadequateDetail = ({ data }) => {
  return (
    <SecurityDetail
      data={data}
      criticality='critical'
      adequacy='inadequate'
    />
  );
};

SecurityCriticalInadequateDetail.propTypes = {
  data: PropTypes.object.isRequired
};

export default SecurityCriticalInadequateDetail;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityCriticalInadequateDetail.js